export enum TramoActions {
  ENABLE = 'Enable',
  DISABLE = 'Disable',
}
